import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDeliveryArticleTags } from '../../api/fetch-delivery-article-tags';

export const fetchDeliveryArticleTagsThunk = createAsyncThunk(
    'fetchDeliveryArticleTags',
    async () => fetchDeliveryArticleTags(),
);
